export const STATS_MAP = {
  wechat: {
    exposure: 'h5-private-qrCode-exposure',
    click: 'h5-private-qrCode-click',
    longpress: 'h5-private-qrCode-longPress',
  },
  prize: {
    exposure: 'h5-private-prize-exposure',
    click: 'h5-private-prize-click',
  },
  cardAd: {
    exposure: 'h5-card-ad-exposure',
    click: 'h5-card-ad-click',
  },
}
